import { render, staticRenderFns } from "./AK1Icon.vue?vue&type=template&id=feb212cc&"
import script from "./AK1Icon.vue?vue&type=script&lang=js&"
export * from "./AK1Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK1Icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports